// Staff-specific form field combinations
// These are specific to staff/employee management and not truly global
import React from 'react';
import { Row, Col } from 'antd';
import { SelectField, PhoneField } from '../../../../../components/UI/FormFields';

/**
 * Staff-specific Phone and Gender Row Component
 * Combines phone and gender fields in a row layout for staff forms
 */
export const PhoneGenderRow = ({ 
  genderOptions = [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' },
    { value: 'other', label: 'Other' }
  ], 
  readOnly = false,
  phoneProps = {},
  genderProps = {}
}) => (
  <Row gutter={16}>
    <Col span={12}>
      <PhoneField 
        readOnly={readOnly}
        {...phoneProps}
      />
    </Col>
    <Col span={12}>
      <SelectField
        name="gender"
        label="Gender"
        placeholder="--Select Gender--"
        options={genderOptions}
        required
        readOnly={readOnly}
        {...genderProps}
      />
    </Col>
  </Row>
);

/**
 * Staff-specific Team and Role Row Component
 * Combines team and role selection fields for staff assignment
 * Now supports multiple team selection
 */
export const TeamRoleRow = ({ 
  teamOptions = [], 
  roleOptions = [], 
  isLoadingTeams = false, 
  isLoadingRoles = false,
  readOnly = false,
  teamProps = {},
  roleProps = {}
}) => (
  <Row gutter={16}>
    <Col span={12}>
      <SelectField
        name="team"
        label="Assign Team"
        placeholder="--Select Team(s)--"
        options={teamOptions}
        required
        loading={isLoadingTeams}
        readOnly={readOnly}
        mode="multiple"
        {...teamProps}
      />
    </Col>
   
  </Row>
);

/**
 * Staff-specific Location Field Component
 * Location selection field for staff assignment
 * Now supports multiple location selection
 */
export const LocationField = ({ 
  locationOptions = [], 
  isLoadingLocations = false, 
  readOnly = false,
  name = "locationId",
  ...props 
}) => (
  <SelectField
    name={name}
    label="Location"
    placeholder="--Select Location(s)--"
    options={locationOptions}
    required
    loading={isLoadingLocations}
    readOnly={readOnly}
    mode="multiple"
    {...props}
  />
);